import { render, staticRenderFns } from "./Conference.vue?vue&type=template&id=b058b346&scoped=true"
import script from "./Conference.vue?vue&type=script&setup=true&lang=js"
export * from "./Conference.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Conference.vue?vue&type=style&index=0&id=b058b346&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b058b346",
  null
  
)

export default component.exports